import { render, staticRenderFns } from "./details-drawer.vue?vue&type=template&id=a95a3018&scoped=true"
import script from "./details-drawer.vue?vue&type=script&lang=js"
export * from "./details-drawer.vue?vue&type=script&lang=js"
import style0 from "./details-drawer.vue?vue&type=style&index=0&id=a95a3018&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95a3018",
  null
  
)

export default component.exports